export class FormBuilderPaymentOptions {
  public AllowBillMeOption: boolean;
  public AllowCreditCardOption: boolean;
  public AllowBillMeOptionText: string;
  public AllowCreditCardOptionText: string;
  public AllowArb: boolean;
  public CreateInvoiceChargeOnSubmit: boolean;
  public RequireArb: boolean;
  public PreventMembershipOnBillMe: boolean;
  public AllowArbOptionText: string;

  public constructor() {
    this.AllowBillMeOption = false;
    this.AllowCreditCardOption = false;
    this.AllowArb = false;
    this.CreateInvoiceChargeOnSubmit = true;
    this.AllowBillMeOptionText = '';
    this.AllowCreditCardOptionText = '';
    this.PreventMembershipOnBillMe = false;
    this.AllowArbOptionText = '';
  }
}
